
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class VEmptyState extends Vue {
  @Prop({ type: String, default: '' }) public text!: string;
  @Prop({ type: String, default: '' }) public action!: string;
  @Prop({ type: Boolean, default: false }) public noAction!: boolean;
}
